authCtrl.$inject = [];

export default function authCtrl() {

}
